import { getContractsQueryQMin } from '@/api/generated/endpoints/contracts/contracts.zod';
import { Button } from '@/components/ui/button';
import { SearchInput } from '@/components/ui/search-input';

export function SearchForm({
  value,
  onValueChange,
  onSubmit,
  onClear,
}: {
  value: string;
  onValueChange: (value: string) => void;
  onSubmit: () => void;
  onClear: () => void;
}) {
  const canSearch = value.trim().length >= getContractsQueryQMin;

  return (
    <div className="flex flex-col gap-2 px-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <SearchInput
          value={value}
          onValueChange={onValueChange}
          onClear={onClear}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && canSearch) {
              onSubmit();
            }
          }}
        />
        <Button
          onClick={onSubmit}
          disabled={!canSearch}
          className="shrink-0 text-base font-medium uppercase"
        >
          Search
        </Button>
      </div>
      <p className="intl-text-body-small intl-text-tertiary">
        Type at least {getContractsQueryQMin} characters and press Enter or
        Search.
      </p>
    </div>
  );
}
